import * as types from "../constants/actionTypes";
import { getCountries } from "../api/countries";
import { generateAsyncAction } from "./generateAsyncAction";

export const setCountry = country => dispatch => {
  dispatch({
    type: types.SET_COUNTRY,
    payload: country
  });
};

export const getCountriesList = () => async dispatch => {
  dispatch({ type: types.GET_COUNTRIES_REQUEST });
  const getCountriesAction = await generateAsyncAction({
    onFailAction: countriesFailed,
    onSuccessAction: countriesSuccess,
    asyncApiMethod: getCountries
  });
  return dispatch(getCountriesAction);
};

export const countriesSuccess = ({ payload }) => dispatch => {
  dispatch({
    type: types.GET_COUNTRIES_SUCCESS,
    payload: payload
  });
};

const countriesFailed = ({ message, title }) => ({
  type: types.GET_COUNTRIES_FAILED,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/countriesActions.js